import styled from 'styled-components';
import { Typography } from '~/ui/components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const FilePreviewContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 16px;
  border-top: 1px solid ${({ theme }) => theme.colors.divider.primary};
  padding-top: 16px;
  max-height: 285px;
  overflow: auto;
  transition: all 0.2s ease-in-out;

  &::-webkit-scrollbar {
    width: 3px;
    background-color: transparent;
  }

  &::-webkit-scrollbar-track {
    background-color: transparent;
  }
`;

export const UploadArea = styled.div<{ isDragging: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 16px;
  border-radius: 16px;
  background-color: ${({ isDragging, theme }) =>
    isDragging ? theme.colors.background.tertiary : theme.colors.background.secondary};
  transition: all 0.2s ease-in-out;
  cursor: pointer;
  gap: 16px;
  opacity: ${({ isDragging }) => (isDragging ? 0.5 : 1)};

  &:hover {
    background-color: ${({ theme }) => theme.colors.background.tertiary};
  }
`;

export const Content = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  gap: 8px;
  width: 100%;
`;

export const InfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  max-width: 180px;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  flex: 1;
  max-width: 180px;
`;

export const Title = styled(Typography).attrs({
  element: 'h3',
  type: 'bodySmall',
  weight: '700',
})``;

export const Description = styled(Typography).attrs({
  element: 'p',
  type: 'bodyXSmall',
})``;

export const FilePreviewItem = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  .file-icon {
    color: ${({ theme }) => theme.colors.brand.primaryAlt};
    fill: ${({ theme }) => theme.colors.brand.primaryAlt};
  }
`;

export const FileInfo = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`;

export const FileName = styled(Typography).attrs({
  element: 'span',
  type: 'bodyXSmall',
})``;

export const FileSize = styled(Typography).attrs({
  type: 'description',
  element: 'span',
})``;

export const FileActions = styled.div`
  display: flex;
  align-items: center;
`;

export const RemoveButton = styled.button`
  background: none;
  border: none;
  color: ${({ theme }) => theme.colors.brand.primary};

  cursor: pointer;
  transition: color 0.2s ease-in-out;

  &:hover {
    color: ${({ theme }) => theme.colors.brand.primaryAlt};
  }

  svg {
    pointer-events: none;
  }
`;
